import { render, staticRenderFns } from "./resultsGraphSPL2.vue?vue&type=template&id=2ef99b56"
import script from "./resultsGraphSPL2.vue?vue&type=script&lang=js"
export * from "./resultsGraphSPL2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports